import {$, ID, Resource, ResponseSerialize} from 'simpli-web-sdk'
import AuditByDeliveryResponseSchema from '@/schema/AuditByDeliveryResponse.schema'
import Carga from '@/model/resource/Carga'
import EmailAuditoriaEnvio from '@/model/resource/EmailAuditoriaEnvio'

export default class AuditByDeliveryResponse extends Resource {

  readonly $name: string = 'AuditByDeliveryResponse'
  readonly $endpoint: string = '/user/indicador/auditoria-entrega'

  get $id() {
    if (!this.carga) return 0
    return this.carga.$id
  }
  set $id(val: ID) {
    if (!this.carga) this.carga = new Carga()
    this.carga.$id = val
  }

  get $schema() {
    return AuditByDeliveryResponseSchema(this)
  }

  @ResponseSerialize(Carga)
  carga: Carga | null = null

  @ResponseSerialize(EmailAuditoriaEnvio)
  emailAuditoriaEnvio: EmailAuditoriaEnvio | null = null

  get emailEnviado() {
    if ((this.emailAuditoriaEnvio && this.emailAuditoriaEnvio.emailNivel) && (this.carga && this.carga.auditoria)) {
      if (this.emailAuditoriaEnvio.idEmailAuditoriaEnvioPk === 0) {
        return $.tc('classes.AuditByDeliveryCsvResponse.columns.notNotified')
      } else if (this.emailAuditoriaEnvio.emailNivel.idEmailNivelPk !== 0 &&
          this.emailAuditoriaEnvio.emailNivel.titulo) {
        return this.emailAuditoriaEnvio.emailNivel.titulo
      } else {
        return $.tc('classes.AuditByDeliveryCsvResponse.columns.all')
      }
    } else {
      return $.tc('classes.AuditByDeliveryCsvResponse.columns.notNotified')
    }
  }
}
